import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class StyleIcons extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    let initData = [];
    if(this.props.initData) {
      initData = this.props.initData;
    }

    this.state = {
      vintage: initData.includes('vintage'),
      classic: initData.includes('classic'),
      contemporary: initData.includes('contemporary'),
    };
  }

  componentDidMount() {
    
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.resetElement != prevProps.resetElement) {
      this.resetData();
    }
  }

  resetData() {
    let initData = [];

    this.setState({
      vintage: initData.includes('vintage'),
      classic: initData.includes('classic'),
      contemporary: initData.includes('contemporary'),
    });
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  concatValues() {
    let returnArray = [];
    for (const key in this.state) {
      if(this.state[key]) {
        returnArray.push(key.charAt(0).toUpperCase() + key.slice(1));
      }
    }
    if(returnArray.join(',').length) {
      return [ returnArray.join(',') ];
    } else {
      return [ Object.keys(this.state).join(',') ];
    }
  }

  toggleShapeSelect(shape) {

    if(shape == 'vintage') {
      this.setState({ vintage: !this.state.vintage }, () => {
        this.props.refreshData(this.props.searchType, ['style'], this.concatValues());
      });
    } else if(shape == 'classic') {
      this.setState({ classic: !this.state.classic }, () => {
        this.props.refreshData(this.props.searchType, ['style'], this.concatValues());
      });
    } else if(shape == 'contemporary') {
      this.setState({ contemporary: !this.state.contemporary }, () => {
        this.props.refreshData(this.props.searchType, ['style'], this.concatValues());
      });
    }
  }

  selectAllShapes() {

    let toggleValue = false;
    for(const key in this.state) {
      if(!this.state[key]) {
        toggleValue = true;
        break;
      }
    }
    
    this.setState({
      vintage: toggleValue,
      classic: toggleValue,
      contemporary: toggleValue,
    }, () => {
      this.props.refreshData(this.props.searchType, ['style'], this.concatValues());
    });
  }

  render() {
    return <div className='StyleIcons'>
      <div className='iconsWrapper'>
        <div className='hiddenLoading'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_1.svg' />
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_a_1.svg' />
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic.svg' />
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic_a.svg' />
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary.svg' />
          <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary_a.svg' />
        </div>
        <div className='iconRow'>
          <div 
            className={this.state.vintage ? 'shapeIconWrapper selected' : 'shapeIconWrapper'}
            onClick={() => this.toggleShapeSelect('vintage')}>
            <img className='imgNotSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_1.svg' />
            <img className='imgSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_a_1.svg' />
            <div className='iconLabel'>Vintage</div>
          </div>
          <div 
            className={this.state.classic ? 'shapeIconWrapper selected' : 'shapeIconWrapper'}
            onClick={() => this.toggleShapeSelect('classic')}>
            <img className='imgNotSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic.svg' />
            <img className='imgSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic_a.svg' />
            <div className='iconLabel'>Classic</div>
          </div>
          <div 
            className={this.state.contemporary ? 'shapeIconWrapper selected' : 'shapeIconWrapper'}
            onClick={() => this.toggleShapeSelect('contemporary')}>
            <img className='imgNotSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary.svg' />
            <img className='imgSelected' src='https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary_a.svg' />
            <div className='iconLabel'>Contemporary</div>
          </div>
        </div>
      </div>
      <div className='allLinkWrapper'>
        <div className='allLink' onClick={::this.selectAllShapes}>All</div>
      </div>
    </div>;
  }
}
export default StyleIcons;

function mapStateToProps(state) {
  return {

  };
}

export const StyleIconsContainer = connect(
  mapStateToProps,
  allActionCreators
)(StyleIcons);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filterElements/StyleIcons.jsx